// extracted by mini-css-extract-plugin
module.exports = {"pageButtonSlider":"styles_pageButtonSlider__BEu1i","pageButtonSliderDot":"styles_pageButtonSliderDot__iykuK"};